import { Avatar, Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import ClearTwoToneIcon from "@mui/icons-material/ClearTwoTone";

export default function EmptyListIndicator({ name }: { name: string }) {
  return (
    <Box
      sx={{
        display: "flex", padding: 1, flexDirection: "column", alignItems: "center"
      }}
    >
      <Avatar variant="rounded" sx={{ bgcolor: grey[400] }}>
        <ClearTwoToneIcon />
      </Avatar>
      <Typography sx={{marginTop: 0.5}} variant="subtitle2" display="block">
        Es wurde kein {name} gefunden.
      </Typography>
    </Box>
  );
}
